import { Pagination } from 'ra-ui-materialui'
import React from 'react'
import { PaginationProps } from 'react-admin'

const PER_PAGE_OPTIONS = [20, 40]

const KPagination: React.FC<PaginationProps> = (props) => {
  return <Pagination rowsPerPageOptions={PER_PAGE_OPTIONS} {...props} />
  // const { page, perPage, total, setPage } = useListContext()
  // // const nbPages = Math.ceil(total / perPage) || 1
  // return (
  //   <Toolbar>
  //     {/* {page > 1 && ( */}
  //     <Button
  //       color="primary"
  //       label="Prev"
  //       key="prev"
  //       onClick={() => setPage(page - 1)}
  //     >
  //       <ChevronLeft />
  //     </Button>
  //     {/* )} */}
  //     {/* {page !== nbPages && ( */}
  //     <Button
  //       color="primary"
  //       label="Next"
  //       key="next"
  //       onClick={() => setPage(page + 1)}
  //     >
  //       <ChevronRight />
  //     </Button>
  //     {/* )} */}
  //   </Toolbar>
  // )
}

export default KPagination
